import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { kebabCase } from 'lodash';
import cookie from 'react-cookies';
import { Link, Image, WebinarBanner } from '..';
import Logo from 'assets/images/logo-menu.svg';
import LogoWhite from 'assets/images/brand/logo-white.svg';
import { PATHS } from 'config';
import { AnnouncementBannerSpace } from '../AnnouncementBanner';
import './NavBar.scss';

export const STICKY_BANNER_COOKIE = 'newsletter-banner-1-accepted';

class NavBar extends Component {

  constructor(props) {
    super(props);

    this.state = {
      isTop: true,
      menuActive: false,
      showSubpages: false,
      scrollPosition: 0,
      bannerActive: false,
    };
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
    this.checkBanner();
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll = () => {
    const scrollOffset = 30;
    if (this.props.show)
      this.setState({ isTop: window.scrollY < scrollOffset });
    else if (!this.props.show)
      this.setState({
        isTop:
          window.scrollY === 0 || window.scrollY > this.state.scrollPosition,
        scrollPosition: window.scrollY,
      });
  };

  closeMenu = () => {
    this.setState({ menuActive: false });
    this.setState({ showSubpages: false });
    if (typeof document !== 'undefined')
      document.body.classList.remove('block-scroll');
  };

  checkBanner =() => {
    this.setState({ bannerActive: cookie.load(STICKY_BANNER_COOKIE) !== 'true' });
  }

  toggleMenu = () => {
    this.setState(prevState => ({ menuActive: !prevState.menuActive }));
    this.setState({ showSubpages: false });
    this.toggleScroll();
  };

  toggleScroll = () => {
    if (typeof document !== 'undefined' && !this.state.menuActive)
      document.body.classList.add('block-scroll');
    else if (typeof document !== 'undefined')
      document.body.classList.remove('block-scroll');
  };

  closeBanner = () => {
    this.setState({ bannerActive: false });
    cookie.save(STICKY_BANNER_COOKIE, true, { path: '/' });
  };

  renderNavItems = () =>
    PATHS.map(item => {
      const { showSubpages } = this.state;
      const { link, isAnchor, name, onlyFooter, children } = item;
      const { hash, pathname } = window.location;
      const selector = link.substr(1);
      const pathnameBase = `/${pathname.split('/')[1]}`;
      const isActive =
        link === `${pathnameBase}/` || (isAnchor && selector === hash);
      const childrenShown = showSubpages ? 'show-services' : 'hide-services';

      const renderChildren = () =>
        children.map(child => (
          <li className={'dropdown__item'} key={child.name}>
            <Link
              className={'dropdown__link'}
              to={child.link}
              onClick={this.closeMenu}
              id={`top-nav-${kebabCase(child.name.toLowerCase())}`}
            >
              {child.name}
            </Link>
          </li>
        ));

      return (
        !onlyFooter && (
          <li
            key={name}
            className={`navbar__menu-item ${children ? 'dropdown' : ''} ${
              isActive ? 'active' : ''
            } ${childrenShown}`}
          >
            <div className="navbar__item-wrapper">
              {children && (
                <button
                  className={`hamburger hamburger--squeeze ${
                    showSubpages ? 'is-active' : ''
                  }`}
                  type={'button'}
                  onClick={() =>
                    this.setState({ showSubpages: !showSubpages })
                  }
                >
                  <span className="hamburger-inner" />
                </button>
              )}
              <Link
                className={'navbar__menu-link'}
                id={`top-nav-${name.toLowerCase()}`}
                to={link}
                key={`nav-item-${name}`}
                onClick={this.closeMenu}
              >
                {name}
              </Link>
            </div>

            {children && (
              <>
                <span className={'caret hide-mobile hide-tablet'} />
                <ul
                  className={`navbar__dropdown-content ${childrenShown} ${
                    this.props.color[1]
                      ? `navbar__dropdown--${this.props.color[1]}`
                      : ''
                  }`}
                >
                  {children && renderChildren()}
                </ul>
              </>
            )}
          </li>
        )
      );
    });

  render() {
    const { isTop, menuActive, bannerActive } = this.state;
    const { banner } = this.props;
    const textColorClass = this.props.color[0]
      ? `navbar--text-${this.props.color[0]}`
      : 'navbar--text-black';
    const itemHover = this.props.color[2]
      ? `navbar--hover-${this.props.color[2]}`
      : 'navbar--hover-violet';
    const isActive = menuActive ? 'is-active' : '';

    const isBannerActive = banner && bannerActive;

    return (
      <>
        {isBannerActive && <AnnouncementBannerSpace />}
        <div
          className={`navbar ${textColorClass} ${itemHover} ${isActive} ${
            isTop ? '' : 'navbar--scrolled'
          } ${this.props.show ? '' : 'navbar--hidden'} ${this.props.style}`}
        >
          {isBannerActive && (
            <WebinarBanner {...banner} onClose={this.closeBanner} />
          )}
          <header className={'navbar__brand w-container'}>
            <div className={'navbar__logos '}>
              <Link
                to={'/'}
                className={'navbar__logo-container'}
                id={'navbar-logo'}
              >
                <Image
                  src={this.props.show ? LogoWhite : LogoWhite}
                  additionalClass={'navbar__logo--img hide-desktop'}
                  alt={'Boldare logo'}
                />
                {(isTop && this.props.color[0] === 'white') ||
                !this.props.show ? (
                  <Image
                    src={LogoWhite}
                    additionalClass={
                      'navbar__logo--img hide-mobile hide-tablet'
                    }
                    alt={'Boldare logo'}
                  />
                ) : (
                  <Image
                    src={Logo}
                    additionalClass={
                      'navbar__logo--img hide-mobile hide-tablet'
                    }
                    alt={'Boldare logo'}
                  />
                )}
              </Link>
            </div>
            <nav
              id={'navMenu'}
              className={`navbar__menu ${isActive}`}
              aria-label={'main navigation'}
            >
              {typeof window !== 'undefined' &&
                window.location &&
                this.renderNavItems()}
            </nav>
            {typeof window !== 'undefined' && window.location && (
              <a
                id={'contact-navbar'}
                href="mailto:hello@boldare.com"
                className={`navbar__email contact-mail ${
                  window.location.pathname === '/' ? 'navbar__email--home' : ''
                }`}
              >
                {'hello@boldare.com'}
              </a>
            )}
            <button
              className={`hamburger hamburger--collapse ${isActive}`}
              type={'button'}
              onClick={this.toggleMenu}
            >
              <span className="hamburger-box">
                <span className="hamburger-inner" />
              </span>
            </button>
          </header>
        </div>
      </>
    );
  }
}

NavBar.defaultProps = {
  color: ['', ''],
  show: true,
  style: [''],
  banner: null,
};

NavBar.propTypes = {
  color: PropTypes.array,
  show: PropTypes.bool,
  style: PropTypes.array,
  banner: PropTypes.shape({}),
};

export default NavBar;
